// export const BASE_URL = 'https://emerald-pos-api.beetronix.com/api'
// export const BASE_URL = 'https://pos-api.mirta.net/api'
// export const BASE_URL = 'http://beeserver:114/api'
export const BASE_URL = 'https://pos-mirror-api.mirta.net/api'
// export const BASE_URL = 'https://pos-1-api.beetronix.com/api'
// export const BASE_URL = 'https://pos-2-api.beetronix.com/api'
// export const BASE_URL = 'http://localhost:39472/api/'
export const VERSION = '1.12.2'